// apps/web/src/components/EmptyState.tsx
import { useTranslation } from 'react-i18next';

export function EmptyState() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center py-20 gap-4">
      <p className="text-6xl">🐪</p>
      <p className="text-lg text-charcoal/60 dark:text-charcoal-light/60 text-center max-w-xs">
        {t('shelf.empty')}
      </p>
    </div>
  );
}
